import { useClickOutside } from '../../hooks/useClickOutside';
import React, { useState, useRef, useLayoutEffect } from 'react';
import WorkspaceMenu from './WorkspaceMenu';
import {
    WorkspaceHeader as Header,
    WorkspaceTitle,
    ProjectCount,
    WorkspaceActions,
    CollapseButton,
    TitleWithTooltip,
    TooltipText,
    Title
} from '../../styles/WorkspaceSection.styles';
import AddProjectModal from '../AddProjectModal';
import PlusIcon from '../../components/icons/PlusIcon';

const WorkspaceHeader = ({
    workspace,
    projectCount,
    showSettings,
    setShowSettings,
    onSettingsClick,
    onManageMembers,
    onMoveProjects,
    onDelete,
    isCollapsed,
    setIsCollapsed,
    isSingleRow,
    setIsSingleRow,
    onEditWorkspace
}) => {
    const menuRef = useRef();
    const tooltipRef = useRef(null);
    const [tooltipPosition, setTooltipPosition] = useState({ left: '50%', transform: 'translateX(-50%)' });
    const [showAddProjectModal, setShowAddProjectModal] = useState(false);

    useClickOutside(menuRef, () => setShowSettings(false));

    useLayoutEffect(() => {
        if (tooltipRef.current) {
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            const viewportWidth = window.innerWidth;

            if (tooltipRect.left < 0) {
                setTooltipPosition({ left: '0', transform: 'translateX(0)' });
            } else if (tooltipRect.right > viewportWidth) {
                setTooltipPosition({ left: 'auto', right: '0', transform: 'translateX(0)' });
            } else {
                setTooltipPosition({ left: '50%', transform: 'translateX(-50%)' });
            }
        }
    }, [workspace.description]);
    
    return (
    <Header ref={menuRef}>
        <WorkspaceTitle>
            <TitleWithTooltip>
                <Title>{workspace.name}</Title>
                {workspace.description && <TooltipText ref={tooltipRef} style={tooltipPosition}>{workspace.description}</TooltipText>}
            </TitleWithTooltip>
            <ProjectCount>
                {projectCount} {projectCount === 1 ? 'project' : 'projects'}
            </ProjectCount>
        </WorkspaceTitle>
        <WorkspaceActions>
            <CollapseButton onClick={() => setIsCollapsed(!isCollapsed)} title={isCollapsed ? "Expand" : "Collapse"}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ transform: isCollapsed ? 'rotate(-180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease-in-out' }}>
                    <path d="M6 9l6 6 6-6"/>
                </svg>
            </CollapseButton>
            <CollapseButton onClick={() => setIsSingleRow(!isSingleRow)} title={isSingleRow ? "Multiple Rows" : "Single Row"}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ transform: isSingleRow ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease-in-out' }}>
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
            </CollapseButton>
            <CollapseButton onClick={() => setShowAddProjectModal(true)} title="Add Project">
                <PlusIcon width={20} height={20} />
            </CollapseButton>
            <WorkspaceMenu
                showSettings={showSettings}
                onSettingsClick={onSettingsClick}
                onManageMembers={onManageMembers}
                onMoveProjects={onMoveProjects}
                onDelete={onDelete}
                onEdit={onEditWorkspace}
            />
        </WorkspaceActions>
        {showAddProjectModal && (
            <AddProjectModal
                workspaceId={workspace.id}
                onClose={() => setShowAddProjectModal(false)}
            />
        )}
    </Header>
)
};

export default WorkspaceHeader;
